import { formatDistanceToNow, parseISO, format } from "date-fns";

export const formatPostTime = (isoDate) => {
  const date = parseISO(isoDate);

  const timeAgo = formatDistanceToNow(date, { addSuffix: true }); // e.g., "3 hours ago"

  const fullDate = format(date, "PPpp"); // e.g., "Dec 10, 2025 at 10:31 PM"

  return { timeAgo, fullDate };
};
